export default __webpack_public_path__ + "static/media/logo.6ba92afb.svg";